import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../redux/store";

type RoutingType = "DB" | "CB";
// type RoutingType = string;

export const useAppRoutingType = () => {
  const user = useSelector((state: RootState) => state.userData.data);
  const appRoutingType: RoutingType = user?.routingTypeCode;
  const isDB = useMemo(() => appRoutingType === "DB", [appRoutingType]);
  const isCB = useMemo(() => appRoutingType === "CB", [appRoutingType]);

  return {
    appRoutingType,
    isDB,
    isCB,
  };
};
